import React from "react";
import { Page } from "./Page";
import { MainContent } from "./MainContent";

export const MainPage: React.FC = () => {
  return <Page content={MainContent} title="Main Page" />;
};
